import React from 'react';
import Header from '../components/Header';
import CredibilitySection from '../components/CredibilitySection';
import HeroSection from '../components/HeroSection';
import TrustedBySection from '../components/TrustedBySection';
import TasksCompletedSection from '../components/TasksCompletedSection';
import AgentsSection from '../components/AgentsSection';
import EcosystemSection from '../components/EcosystemSection';
import RevenueTestimonialSection from '../components/RevenueTestimonialSection';
import SolutionsSection from '../components/SolutionsSection';
import IntegrationsSection from '../components/IntegrationsSection';
import ClinicianLeadersSection from '../components/ClinicianLeadersSection';
import Footer from '../components/Footer';
import PricelessCtaSection from '../components/PricelessCtaSection';

const DentalLandingBackup5 = () => {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Header />
      <HeroSection />
      <TrustedBySection />
      <TasksCompletedSection />
      {/* <CredibilitySection /> */}
      <AgentsSection />
      <EcosystemSection />
      <RevenueTestimonialSection />
      <SolutionsSection />
      <IntegrationsSection />
      {/* <ClinicianLeadersSection /> */}
      <PricelessCtaSection />
      <Footer />
    </div>
  );
};

export default DentalLandingBackup5;
